import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SolutionsVideoSection from './components/SolutionsVideoSection';
import BusinessChallengesSection from './components/BusinessChallengesSection';

export default function SolutionsPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-background-50">
        <SolutionsVideoSection />
        <BusinessChallengesSection />
      </main>
      <Footer />
    </>
  );
}